import { Link } from "react-router-dom";

import styled, { keyframes } from "styled-components";

const errorAnimation = keyframes`
 0% {
    transform: 0;
 }
  50% {
    transform: translateY(-3px);
  }
  100%{
  transform: translateY(0);
  }
`;
export const StyledSection = styled.section`
  padding: 5rem 1rem;
`;

export const ParrentError = styled.div`
  min-height: 200px;
  img {
    animation: ${errorAnimation} 1.7s infinite ease-in-out;
  }
  h2 {
    color: var(--blue-color-dark);
    font-size: var(--font-size-lg);
    margin: 3rem 0 2rem;
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-sm);
    }
  }
`;

export const StyledLink = styled(Link)`
  column-gap: 1rem;
  @media screen and (max-width: 576px) {
    font-size: var(--font-size-sm);
  }
`;
